export default __webpack_public_path__ + "static/media/apa.507dc78b.jpg";